<template>
  <v-app>
    <v-main>
      <v-container id="contenedor" fluid>
        <v-row class="justify-center">
          <v-col>
            <v-card>
              <v-toolbar dark color="primary">
                <v-toolbar-title>Consultor</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-row v-if="loading" class="mt-6">
                  <v-col cols="12" class="text-center">
                    Cargando...
                    <v-progress-linear color="primary accent-4" indeterminate rounded height="10" />
                  </v-col>
                </v-row>
                <v-row v-else class="mt-6">
                  <v-col cols="12">
                    <v-select
                      v-model.number="faseSelected" :items="fases" label="(*) Fases" item-text="fspDescripcion"
                      item-value="fspCodigo" placeholder="Fases de Prueba" dense
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model.number="sedeSelected" :items="sedesAll" label="Ingrese Sede a Buscar"
                      item-text="sede.sedNombre" item-value="sedCodigo"
                    />
                  </v-col>
                </v-row>
                <v-row v-if="error">
                  <v-col>
                    <v-alert color="error" type="warning">
                      {{ error }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="mt-4">
              <v-card-title>
                Delegados
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="headersDelegado" :items="delegados" class="elevation-0" hide-default-footer disable-pagination
                  :loading="loadingTable"
                >
                  <template #item.ingresar="{ item }">
                    <v-btn class="mx-2" fab small color="secondary" @click="suplantar(item)">
                      <v-icon dark>
                        arrow_forward
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="mt-4">
              <v-card-title>
                Usuarios por Sede de Rendición
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="headers" :items="usuarios" class="elevation-0" hide-default-footer
                  disable-pagination :loading="loadingTable"
                >
                  <template #item.local="{ item }">
                    {{ `N° ${item.local.nroLocal} | ${item.lapCodigo} - ${item.local.nombre}` }}
                  </template>
                  <template #item.ingresar="{ item }">
                    <v-btn class="mx-2" fab small color="secondary" @click="suplantar(item)">
                      <v-icon dark>
                        arrow_forward
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="d-flex justify-center">
                <v-btn color="secondary" class="mb-4" @click="$router.push({ name: 'logout' });">
                  <v-icon dark>
                    exit_to_app
                  </v-icon> Salir
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { jwtDecode } from "jwt-decode";
import graphql from '../src/utils/graphql';

export default {
  data() {
    return {
      fases: [],
      faseSelected: null,
      sedeSelected: null,
      usuarios: [],
      delegados:[],
      loading: false,
      loadingTable: false,
      error: '',
      loadingSedes: false,
      vigenciaModuloFase: [],
      sedesAll:[]
    }
  },
  computed: {
    headers() {
      const headers = [
        { text: 'Usuario', value: 'usuario', sortable: false, align: 'center' },
        { text: 'Rol', value: 'rol.nombre', sortable: false, align: 'center' },
        { text: 'Local', value: 'local', sortable: false, align: 'center' },
        { text: 'Ingresar', value: 'ingresar', sortable: false, align: 'center' },
      ];
      return headers;
    },
    headersDelegado() {
      const headers = [
        { text: 'Usuario', value: 'usuario', sortable: false, align: 'center' },
        { text: 'Ingresar', value: 'ingresar', sortable: false, align: 'center' },
      ];
      return headers;
    },
    dataSearch() {
      const token = window.localStorage.getItem('token');
      const {dataSearch} = jwtDecode(token);
      if (dataSearch) {
        return dataSearch;
      }
      return null;
    }
  },
  watch: {
    async faseSelected(val) {
      this.error = '';

      if (!this.vigenciaModuloFase.includes(val)) {
        this.error = 'El módulo asociado a la fase no se encuentra vigente';
        this.sedesAll = [];
        return;
      }
      await this.getSedesByFase();
    },
    async sedeSelected() {
      this.error = '';
      this.usuarios = [];
      this.delegados = [];
      if (this.sedeSelected) {
        await this.getUsuariosRolesBySede();
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.getFasesPrueba();
    if (this.dataSearch) {
      const {fspCodigo, sedCodigo} = this.dataSearch;
      this.faseSelected = fspCodigo;
      this.sedeSelected = sedCodigo;
    }
    this.loading = false;
  },
  methods: {
    async getFasesPrueba() {
      try {
        const query = {
          query: `
            query {
                fases: fasePrueba {
                    fspCodigo
                    fspDescripcion
                    vigente
                }
                modulos: moduloById(nombre: "consultor") {
                  fase {
                    fspCodigo
                    fechaInicio
                    fechaFin
                  }
                }
            }`
        };
        const { fases, modulos } = await graphql.request(query);
        if (modulos.fase) {
          this.vigenciaModuloFase = modulos.fase.map(m => m.fspCodigo);
        }
        this.fases = fases.filter(f => f.vigente);
      } catch (err) {
        this.error = 'No se pudo obtener los datos de fases';
      }
    },
    async getSedesByFase() {
      this.loadingSedes = true;
      this.sedesFiltered = [];
      try {
        const query = {
          query: `
            query ($fspCodigo: Int! ) {
                sedes: sedesByFase(fspCodigo: $fspCodigo) {
                    sedCodigo
                    sede {
                      sedNombre
                    }
                }
            }
            `,
          variables: {
            fspCodigo: this.faseSelected,
          }
        };
        const { sedes } = await graphql.request(query);
        this.sedesAll = [...sedes];
        this.sedesAll.sort((a, b) => a.sede.sedNombre.localeCompare(b.sede.sedNombre));

      } catch (err) {
        this.error = 'No se pudo obtener sedes por fases';
      }
      this.loadingSedes = false;
    },
    async getUsuariosRolesBySede() {
      this.loadingTable = true;
      try {
        const query = {
            query: `
            query ($sedCodigo: Int!, $fspCodigo: Int! ) {
                usuarios: usuariosRolesBySedeFase(sedCodigo: $sedCodigo, fspCodigo: $fspCodigo) {
                    rolCodigo
                    usuario
                    fspCodigo
                    sedCodigo
                    lapCodigo
                    local {
                      nroLocal
                      nombre
                    }
                    rol {
                      nombre
                    }
                }
            }
            `,
            variables : {
              sedCodigo: this.sedeSelected,
              fspCodigo: this.faseSelected,
            }
        };
        const { usuarios } = await graphql.request(query);

        this.delegados = usuarios.reduce((acc, u) => {
          if (!acc.some(a => a.usuario === u.usuario) && u.rolCodigo == 1) {
            acc.push(u);
          }
          return acc;
        },[]);
        this.delegados.sort((a,b)=> a.usuario - b.usuario);
        this.usuarios = usuarios.filter(u => u.rolCodigo == 2);
        this.usuarios.sort((a, b) => {
          if (a.rolCodigo === b.rolCodigo) {
            return a.rolCodigo - b.rolCodigo;
          }
          return a.local.nroLocal - b.local.nroLocal;
        });
      } catch (err) {
        this.error = 'No se pudo obtener usuarios roles';
      }
      this.loadingTable = false;
    },
    async suplantar(item) {
      const token = window.localStorage.getItem('token');
      const response = await fetch(process.env.VUE_APP_SERVER_HOST + '/api/consultor/rebuild-token', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(item),
      });
      const result = await response.json();
      if (result.error) {
        this.error = result.error;
        return;
      }
      window.localStorage.removeItem('token');
      window.location.replace(`/auth?token=${result.newToken}`);
    }
  }
};
</script>
